export default {"src":"/_next/static/media/SysLog.9daec25f.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};